import { Divider, Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import {
  BewareFormVM,
  RegistrationBewareFormVM,
  SubjectAttributesVM,
} from 'mutation/view-models/registration-beware';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import TableBeware from './table-beware';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import AnomaliesForm from './anomalies-form';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import FormBeware from './form-beware';

interface SubjectAttributesForm {
  values?: SubjectAttributesVM | null;
  onChange: (
    key: keyof SubjectAttributesVM,
    value: SubjectAttributesVM[keyof SubjectAttributesVM]
  ) => void;
  errors?: FormikErrors<SubjectAttributesVM>;
  touched?: FormikTouched<SubjectAttributesVM>;
  isBeware?: boolean;
}

const SubjectAttributesFormComponent = ({
  values,
  onChange,
  errors,
  touched,
  isBeware,
}: SubjectAttributesForm): React.ReactElement => {
  const formContext = useFormikContext<RegistrationBewareFormVM>();

  const { userProfile } = useUserProfile();

  const isEditAnomaly = userProfile.datiLogin?.profile?.feature?.authNote === '2';

  const disabledAnomaly = values?.disabled || !isEditAnomaly;

  const handleChangePage = useEventCallback((newPage: number) => {
    formContext.setFieldValue('subjectAttributes', {
      ...(formContext.values?.subjectAttributes || {}),
      page: newPage,
    });
  });

  const handleChangeRowsPerPage = useEventCallback((rowsPerPage: number) => {
    formContext.setFieldValue('subjectAttributes', {
      ...(formContext.values?.subjectAttributes || {}),
      page: 0,
      rowsPerPage,
    });
  });

  const onChangeFormBeware = useEventCallback(
    (key: keyof BewareFormVM, value: BewareFormVM[keyof BewareFormVM]) => {
      onChange('formBeware', {
        ...values?.formBeware,
        [key]: value,
      });
    }
  );

  return (
    <Grid container spacing={1} item xs={12}>
      {isBeware ? undefined : <AnomaliesForm disabled={disabledAnomaly} />}
      {!isBeware ? undefined : (
        <>
          <Grid item xs={12}>
            <PmiTitleDivider>Diffida</PmiTitleDivider>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <FormBeware
              values={values?.formBeware}
              disabled={values?.disabled}
              onChange={onChangeFormBeware}
              touched={touched?.formBeware as unknown as FormikTouched<BewareFormVM>}
              errors={errors?.formBeware as FormikErrors<BewareFormVM>}
            />
          </Grid>
          <TableBeware
            generality={formContext.values?.person?.generality}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            page={formContext.values.subjectAttributes?.page}
            rowsPerPage={formContext.values.subjectAttributes?.rowsPerPage}
          />
        </>
      )}
    </Grid>
  );
};

SubjectAttributesFormComponent.displayName = 'Accordion Subject Attributes - Form component';

const SubjectAttributesForm = memo(SubjectAttributesFormComponent);

export default SubjectAttributesForm;
